import AppLogin from "../../../components/AppLogin";

export { Page };

function Page() {
    return (
        <AppLogin />
    );
}
